/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { FaSnapchatGhost } from "react-icons/fa";
import { FaFacebook, FaTiktok, FaYoutube } from "react-icons/fa6";
import { Link } from "react-router-dom";

export default function Footer() {
  const getYear = () => new Date().getFullYear();
  return (
    <footer style={{ background: "url(images/contact_banner.jpg)" }}>
      <div className="footer_overlay pt_100 xs_pt_70 pb_100 xs_pb_20">
        <div className="container wow fadeInUp" data-wow-duration="1s">
          <div className="row justify-content-between">

            <div className="col-xxl-4 col-lg-4 col-sm-9 col-md-7">
              <div className="footer_content">
                <Link className="footer_logo  mb-3" to="/">
                  <img
                    src="/images/transparentlogo.svg"
                    alt="RegFood"
                    style={{width:'300px'}}
                    className=""
                  />
                </Link>
                {/* <span>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Soluta facere delectus qui placeat inventore consectetur
                  repellendus optio debitis.
                </span> */}
                <ul className="social_link d-flex flex-wrap">
                  <li className="my-auto">
                    <a
                      href="#"
                      className="d-flex align-items-center justify-content-center"
                    >
                      <FaFacebook size={20} />
                    </a>
                  </li>
                  <li className="my-auto">
                    <a
                      href="#"
                      className="d-flex align-items-center justify-content-center"
                    >
                      <FaTiktok size={20} />
                    </a>
                  </li>
                  <li className="my-auto">
                    <a
                      href="#"
                      className="d-flex align-items-center justify-content-center"
                    >
                      <FaYoutube size={20} />
                    </a>
                  </li>

                  <li className="my-auto">
                    <a href="#">
                      <FaSnapchatGhost />
                    </a>
                  </li>
                  <li className="my-auto">
                    <a href="#">
                      <i className="fab fa-instagram" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xxl-2 col-lg-2 col-sm-5 col-md-5">
              <div className="footer_content">
                <h3>Short Link</h3>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use">Terms Of Use</Link>
                  </li>
                  <li>
                    <Link to="/product-and-service">Product & Service</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-sm-9 col-md-7 order-lg-4">
              <div className="footer_content">
                <h3>contact us</h3>
                <p className="info">
                  <i className="fas fa-phone-alt" />
                  <a
                    href="tel:(509)601-2505"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    (509) 601-2505
                  </a>
                </p>

                <p className="info">
                  <a href="mailto:info@afrikanbbq.com" className="text-light">
                    <i className="fas fa-envelope" /> info@afrikanbbq.com
                  </a>
                </p>
                <p className="info">
                  <i className="far fa-map-marker-alt" /> Afrikan BBQ
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_bottom d-flex flex-wrap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer_bottom_text">
                <p>
                  Copyright © <b>Afrikan BBQ LLC.</b> {getYear()}. All Rights
                  Reserved. | Website designed and developed by{" "}
                  <a
                    href="https://hnhsofttechsolutions.com/"
                    target="_blank"
                    className="fw-bold text-white"
                  >
                    {" "}
                    HNH TECH SOFT SOLUTION
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
